import React from 'react';

const Hero = (props) => {
    return <div style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${require('../images/' + props.image)})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        position: 'relative',
        height: '100%'
    }}>{props.children}</div>
}

export default Hero;